import cx from 'classnames';
import { t } from 'i18next';
import { withSiteMeta } from '../../HOCS/withSiteMeta';
import { asset } from '../../services/assetResolverService';
import { Link } from '../link';
import { FC } from 'react';

type TMainNavSiteLogoProps = {
  logoPath: string;
  width: number;
  height: number;
};

function termForPatronage(features: any) {
  if (features.admin) {
    return [t('patreon:ranks.illustrious'), 'text-item-quality--6'];
  } else if (features.premium_5) {
    return [t('patreon:ranks.illustrious'), 'text-item-quality--6'];
  } else if (features.premium_4) {
    return [t('patreon:ranks.exalted'), 'text-item-quality--6'];
  } else if (features.premium_3) {
    return [t('patreon:ranks.revered'), 'text-item-quality--6'];
  } else if (features.premium_2) {
    return [t('patreon:ranks.honored'), 'text-item-quality--6'];
  } else if (features.premium_1) {
    return [t('patreon:ranks.friendly'), 'text-item-quality--6'];
  }
  return '';
}

const MainNavPremiumBlurbBase: FC<any> = (props: any) => {
  const [label, cls] = termForPatronage(props.currentFeatures);
  if (!label) {
    return null;
  }

  return (
    <div
      className={cx(props.className, 'slds-col slds-m-left--small slds-text-body--small')}
      style={{ lineHeight: '0.9rem' }}
    >
      <div className="text-premium-special text-uppercase">{t('patreon:premium')}</div>
      <div className={`text-bold text-uppercase ${cls}`}>{label}</div>
    </div>
  );
};

export const MainNavPremiumBlurb = withSiteMeta(MainNavPremiumBlurbBase);

export const MainNavSiteLogo: FC<TMainNavSiteLogoProps> = (props) => {
  return (
    <div className="slds-grid slds-grid--vertical-align-center">
      <Link to="/" className="slds-col auth-bar--logo">
        <img src={asset(props.logoPath)} alt="RaiderIO Logo" style={{ width: props.width, height: props.height }} />
      </Link>

      <MainNavPremiumBlurb />
    </div>
  );
};
